
import Button from './button.vue'

export default {
  name: 'VisionBottom',
  components: {
    Button
  },
  props: {
    isRecruitPage: {
      type: Boolean,
      default: false
    }
  }
}
